import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

const LinkedInIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <path d="M7.34214286 5.57723112 C7.34214286 6.60113043 6.50964286 7.43077803 5.48214286 7.43077803 C4.45464286 7.43077803 3.62214286 6.60113043 3.62214286 5.57723112 C3.62214286 4.55407323 4.45464286 3.72368421 5.48214286 3.72368421 C6.50964286 3.72368421 7.34214286 4.55407323 7.34214286 5.57723112 Z M7.35714286 8.91361556 L3.60714286 8.91361556 L3.60714286 20.7763158 L7.35714286 20.7763158 L7.35714286 8.91361556 Z M13.3436429 8.91361556 L9.61764286 8.91361556 L9.61764286 20.7763158 L13.3443929 20.7763158 L13.3443929 14.5491396 C13.3443929 11.086714 17.8661429 10.803492 17.8661429 14.5491396 L17.8661429 20.7763158 L21.6071429 20.7763158 L21.6071429 13.2650023 C21.6071429 7.42262243 14.9156429 7.63540961 13.3436429 10.511373 L13.3436429 8.91361556 Z" />
    </SvgIcon>
  );
};

export default LinkedInIcon;
